<template>
  <v-col cols="6">
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step1.title`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.coolingSystemName"
          :label="$t('technicalFile.cooling.step1.coolingSystemName')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.annualMakeUpVolume.value"
          :label="$t('technicalFile.cooling.step1.annualMakeUp')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.annualMakeUpVolume.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('annualMakeUpVolume')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="annualMakeUpVolume"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.annualBlowdownVolume.value"
          :label="$t('technicalFile.cooling.step1.annualBlowdown')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.annualBlowdownVolume.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('annualBlowdownVolume')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="annualBlowdownVolume"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.makeUpSource"
          :label="$t('technicalFile.cooling.step1.makeUpSource')"
          :items="displayedUnits('makeUpSource')"
          :multiple="true"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="makeUpSource"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.blowDownDischargeType"
          :label="$t('technicalFile.cooling.step1.blowDownDischargeType')"
          :items="displayedUnits('blowDownDischargeType')"
          :multiple="true"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="blowDownDischargeType"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.recirculationRate.value"
          :label="$t('technicalFile.cooling.step1.recirculationRate')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.recirculationRate.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('recirculationRate')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="recirculationRate"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.hotReturnTemp.value"
          :label="$t('technicalFile.cooling.step1.hotReturnTemp')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.hotReturnTemp.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('hotReturnTemp')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="hotReturnTemp"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.coldSupplyTemp.value"
          :label="$t('technicalFile.cooling.step1.coldSupplyTemp')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.coldSupplyTemp.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('coldSupplyTemp')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="coldSupplyTemp"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.maximumSkinTemp.value"
          :label="$t('technicalFile.cooling.step1.maximumSkinTemp')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.maximumSkinTemp.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('maximumSkinTemp')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="maximumSkinTemp"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.totalSystemVolume.value"
          :label="$t('technicalFile.cooling.step1.totalSystemVolume')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.totalSystemVolume.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('totalSystemVolume')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="totalSystemVolume"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.systemMetallurgy"
          :label="$t('technicalFile.cooling.step1.systemMetallurgy')"
          :items="displayedUnits('systemMetallurgy')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          :multiple="true"
          outlined
          :readonly="readonly"
          flat
          data-cy="systemMetallurgy"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.deadlegsPresent.enabled"
          :label="$t('technicalFile.cooling.step1.deadlegsPresent')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="deadlegsPresent"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextarea
          v-model="data.deadlegsPresent.note"
          :disabled="data.deadlegsPresent.enabled !== 0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.operationType"
          :label="$t('technicalFile.cooling.step1.operationType')"
          :items="displayedUnits('operationType')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          :multiple="true"
          outlined
          :readonly="readonly"
          flat
          data-cy="operationType"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.durationOfShadowns.value"
          :label="$t('technicalFile.cooling.step1.durationOfShadowns')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.durationOfShadowns.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('durationOfShadowns')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="durationOfShadowns"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.daysInOperation.value"
          :label="$t('technicalFile.cooling.step1.daysInOperation')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.daysInOperation.units"
          :label="$t('technicalFile.cooling.step1.units')"
          :items="displayedUnits('daysInOperation')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="daysInOperation"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.controlSystem"
          :label="$t('technicalFile.cooling.step1.controlSystem')"
          :items="displayedUnits('controlSystem')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          :multiple="true"
          outlined
          :readonly="readonly"
          flat
          data-cy="controlSystem"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'OperatingConditions',
    components: {
        VTextField,
    },
    props: {
        operatingConditions: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                annualMakeUpVolume: {},
                annualBlowdownVolume: {},
                recirculationRate: {},
                hotReturnTemp: {},
                coldSupplyTemp: {},
                maximumSkinTemp: {},
                totalSystemVolume: {},
                deadlegsPresent: {},
                durationOfShadowns: {},
                daysInOperation: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        operatingConditions: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.operatingConditions) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { operatingConditions: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
    padding-bottom: 0;
    padding-top: 0;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
    .text-field-transparent{
      margin-bottom:20px;
    }
}
.bloc {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  left:0 !important
}

@media screen and (min-width: 960px) {
  .bloc {
    transform: translateX(-30px)
  }
}

</style>
